import { defineMessages } from 'react-intl'

/** LuxPlus+ membership copy — see `docs/product-taxonomy.md` §4. */
const luxPlusGlossaryMessages = defineMessages({
  luxPlusProgramName: {
    defaultMessage: 'LuxPlus+',
    id: 'wihKYxaip1tm0eYw-O0P',
    description: 'Program name for LuxPlus+ membership used across account, checkout, and offer surfaces',
  },
  luxPlusYearlyMembership: {
    defaultMessage: 'LuxPlus+ Yearly Membership',
    id: 'ULo9gnL1uIK6CoWu6hg1',
    description: 'Product title for the yearly LuxPlus+ membership line item in checkout and account',
  },
  luxPlusMonthlyMembership: {
    defaultMessage: 'LuxPlus+ Monthly Membership',
    id: 'l-UmUgySYbCf9cnK1xth',
    description: 'Product title for the monthly LuxPlus+ membership line item in checkout and account',
  },
  luxPlusFreePreview: {
    defaultMessage: 'LuxPlus+ Free Preview',
    id: 'o-DAWTTHNBRoW6Q3xZNr',
    description: 'Label for the free preview trial membership in banners, pills, and account surfaces',
  },
  startFreePreview: {
    defaultMessage: 'Start Free Preview now',
    id: 'mjE2LdFDfUGLQ1LitKZ-',
    description: 'Call-to-action encouraging the customer to start a LuxPlus+ free preview trial',
  },
  startDurationFreePreview: {
    defaultMessage: 'Start {duration}-day Free Preview',
    id: 'z30GZaML6-78YeeI2q6T',
    description: 'Call-to-action to start a free preview with a variable trial duration in days',
  },
  vipTravelClubPreview: {
    defaultMessage: 'VIP Travel Club Preview',
    id: 'fBlcyEqJoo5_vRHKDIVg',
    description: 'Marketing label used as an alias for the LuxPlus+ free preview program',
  },
  earlyAccess: {
    defaultMessage: 'Early Access',
    id: '-BoyjWsFd0KgblxBsfC1',
    description: 'Badge for offers that unlock early for members before the general on-sale time',
  },
  earlyAccessWithLuxPlus: {
    defaultMessage: 'Early access with LuxPlus+',
    id: '0VnrinXBoyzq4Yic246V',
    description: 'Short caption for tiles where LuxPlus+ members get early access to the offer',
  },
  memberOnlyOffer: {
    defaultMessage: 'Member-only offer',
    id: 'vdTR3nC52iYAudXEHj-f',
    description: 'Product badge indicating the deal is only available to loyalty or LuxPlus+ members',
  },
  memberPrice: {
    defaultMessage: 'Member price',
    id: 'xMo2bIO0Fl_R-JFwE5F1',
    description: 'Price pill when the rate is a discounted member-only price on a tile or summary',
  },
  memberPriceWithName: {
    defaultMessage: '{programName} member price',
    id: 'QcN-1ofgEwg68jC0wq3T',
    description: 'Branded member price line where the program name is interpolated from configuration',
  },
  memberInclusions: {
    defaultMessage: 'Member inclusions',
    id: 'VGXYAy1-9fkybh_qiaRh',
    description: 'Badge for extras or perks that are only included for members of the program',
  },
  activateFreeMembership: {
    defaultMessage: 'Activate your free membership',
    id: 'imyXSQMZhDmz-nMTsR2f',
    description: 'Onboarding call-to-action to begin a free membership or trial from marketing surfaces',
  },
  becomeAMember: {
    defaultMessage: 'Become a member',
    id: 'Ibbk64pzWK9gYnBkTdMw',
    description: 'Upsell call-to-action to join LuxPlus+ from landing pages, tiles, and modals',
  },
  manageMembership: {
    defaultMessage: 'Manage membership',
    id: 'nwHZAIziJe1M8RdFZP8V',
    description: 'Account navigation and settings link to manage the customer LuxPlus+ subscription',
  },
})

export default luxPlusGlossaryMessages
